import { ISharingUser } from '@/Interfaces/SharingUser.interface';
import { SearchSharesUsersPayload, ShareTargetPayload, SharesMeta } from '@/types/shares.types';
import axios from 'axios';

const FETCH_USERS_ENDPOINT = '/shares/users';
const SHARE_TARGET_ENDPOINT = '/shares';

export const fetchSharesUsers = async (params: SearchSharesUsersPayload): Promise<ISharingUser[]> => {
  const resp = await axios.get(FETCH_USERS_ENDPOINT, { params });
  return resp.data;
};

export const shareTarget = async (payload: ShareTargetPayload): Promise<SharesMeta[]> => {
  const resp = await axios.post(SHARE_TARGET_ENDPOINT, payload);
  return resp.data;
};

export const deleteSharedTarget = async (id: string): Promise<never> => {
  return await axios.delete(`${SHARE_TARGET_ENDPOINT}/${id}`);
};
